export default "__VITE_PUBLIC_ASSET__83bd839f__"